import React from "react";
import { NavLink } from "react-router-dom";
import "./footer.css";

function Footer() {
  return (
    <div className="footer">
      <h1 className="header-logo-footer">Pet Care by Kubra & Zack®</h1>
      <div className="map">
        <div className="navbar">
          <NavLink to="/" end className="navbar-links">
            Home
          </NavLink>
          <NavLink to="/services" className="navbar-links">
            Services
          </NavLink>
          <NavLink to="/contact" className="navbar-links">
            Contact
          </NavLink>
          <NavLink to="/gallery" className="navbar-links">
            Gallery
          </NavLink>
          <NavLink to="/faq" className="navbar-links">
            FAQ
          </NavLink>
          <a
            href="https://www.instagram.com/petcarebykubra/"
            target="_blank"
            rel="noreferrer"
            className="navbar-links navbar-links-a"
          >
            Follow
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#ffffff"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-instagram-icon lucide-instagram"
            >
              <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
              <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
              <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
            </svg>
          </a>
        </div>
      </div>
    </div>
  );
}

export default Footer;